import { ChangeRequestStatus } from "./Status";

export const ChangeRequestStatusColor = (status) => {
    switch (status) {
      case ChangeRequestStatus.DRAFT:
        return "badge-default-grey";
      case ChangeRequestStatus.IN_APPROVAL:
        return "badge-warn-yellow";
      case ChangeRequestStatus.APPROVED:
        return "badge-info-green";
      case ChangeRequestStatus.REJECTED:
        return "badge-rejected-red";
      default:
        return "badge-basic-color";
    }
  };